import { useStores } from "@/stores";
import type { BuildingStoreInstance } from "@/stores/types";

export function useBuildingStore(): BuildingStoreInstance {
  const root = useStores();

  if (!root) {
    throw new Error("Store not initialized - StoreProvider missing?");
  }

  if (!root.buildingStore) {
    throw new Error("BuildingStore not found in root store");
  }

  return root.buildingStore;
}
